import React, { useState } from 'react';

import { ArrowDown } from '../Icons';

import {
  Accordion as AccordionStyled,
  AccordionHeader,
  AccordionContent,
} from './AccordionStyles';

type Props = {
  children: React.ReactNode;
  headerElements: React.ReactNode;
  title?: string;
  color?: string;
  size?: string;
  isOpened?: boolean;
  onClick?(): any;
  className?: string;
};

export const Accordion: React.FC<Props> = ({
  children,
  onClick,
  title,
  size = '10px',
  color = '#BCBCBC',
  headerElements,
  className,
  isOpened,
}) => {
  const [isOpen, setIsOpen] = useState(isOpened ?? false);

  return (
    <AccordionStyled isOpen={isOpen} className={className}>
      <AccordionHeader>
        {headerElements}
        <ArrowDown
          transform={isOpen ? '' : 'rotate(-90deg)'}
          size={size}
          fill={color}
          onClick={() => {
            setIsOpen(!isOpen);
            onClick && onClick();
          }}
        />
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </AccordionStyled>
  );
};
